import { useCallback, useMemo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import PropTypes from 'prop-types';
import { Button } from 'foundations-components/transitional/components/Button';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { H2 } from 'foundations-components/transitional/components/H2';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { FORWARDED_EMAIL, INCOMING_EMAIL, EMAIL, CALL, NOTE, TASK, MEETING, LINKEDIN_MESSAGE, POSTAL_MAIL, SMS, WHATS_APP } from 'customer-data-objects/engagement/EngagementTypes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getEngagementTypeKey = engagementType => {
  switch (engagementType) {
    case CALL:
      return 'timeline.replacePinnedEngagementModal.engagementType.CALL';
    case FORWARDED_EMAIL:
    case INCOMING_EMAIL:
    case EMAIL:
      return 'timeline.replacePinnedEngagementModal.engagementType.EMAIL';
    case MEETING:
      return 'timeline.replacePinnedEngagementModal.engagementType.MEETING';
    case NOTE:
      return 'timeline.replacePinnedEngagementModal.engagementType.NOTE';
    case TASK:
      return 'timeline.replacePinnedEngagementModal.engagementType.TASK';
    case LINKEDIN_MESSAGE:
      return 'timeline.replacePinnedEngagementModal.engagementType.LINKEDIN';
    case POSTAL_MAIL:
      return 'timeline.replacePinnedEngagementModal.engagementType.POSTAL-MAIL';
    case SMS:
      return 'timeline.replacePinnedEngagementModal.engagementType.SMS';
    case WHATS_APP:
      return 'timeline.replacePinnedEngagementModal.engagementType.WHATSAPP';
    default:
      return 'timeline.replacePinnedEngagementModal.engagementType.generic';
  }
};
function ReplacePinnedEngagementModal({
  engagementType,
  hasViewPermissions,
  onCloseModal,
  pinnedEngagementType,
  replacePinnedEngagement
}) {
  const handleReplacePinClick = useCallback(() => {
    replacePinnedEngagement();
    onCloseModal();
  }, [replacePinnedEngagement, onCloseModal]);
  const renderedEngagementTypeMessage = useMemo(() => /*#__PURE__*/_jsx(FormattedMessage, {
    message: getEngagementTypeKey(engagementType)
  }), [engagementType]);
  const renderedPinnedEngagementTypeMessage = useMemo(() => {
    return hasViewPermissions ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: getEngagementTypeKey(pinnedEngagementType)
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "timeline.replacePinnedEngagementModal.engagementType.generic"
    });
  }, [hasViewPermissions, pinnedEngagementType]);
  const renderedBodyMessage = useMemo(() => {
    return hasViewPermissions ? /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "timeline.replacePinnedEngagementModal.body",
      options: {
        engagementType: renderedEngagementTypeMessage
      }
    }) : /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "timeline.replacePinnedEngagementModal.permissionError.body",
      options: {
        engagementType: renderedEngagementTypeMessage
      }
    });
  }, [hasViewPermissions, renderedEngagementTypeMessage]);
  return /*#__PURE__*/_jsxs(Modal, {
    use: "success",
    size: "auto",
    width: 500,
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: onCloseModal
      }), /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "timeline.replacePinnedEngagementModal.title",
          options: {
            pinnedEngagementType: renderedPinnedEngagementTypeMessage
          }
        })
      })]
    }), /*#__PURE__*/_jsx(DialogBody, {
      children: renderedBodyMessage
    }), /*#__PURE__*/_jsxs(DialogFooter, {
      children: [/*#__PURE__*/_jsx(Button, {
        use: "primary",
        onClick: handleReplacePinClick,
        children: /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "timeline.replacePinnedEngagementModal.confirmButton",
          options: {
            engagementType: renderedEngagementTypeMessage
          }
        })
      }), /*#__PURE__*/_jsx(Button, {
        use: "secondary",
        onClick: onCloseModal,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "timeline.replacePinnedEngagementModal.cancelButton"
        })
      })]
    })]
  });
}
ReplacePinnedEngagementModal.propTypes = {
  engagementType: PropTypes.string.isRequired,
  hasViewPermissions: PropTypes.bool,
  onCloseModal: PropTypes.func,
  pinnedEngagementType: PropTypes.string,
  replacePinnedEngagement: PropTypes.func.isRequired
};
export default ReplacePinnedEngagementModal;